import apiClient from './apiService';
import { PurchaseInvoice } from '@/types/invoice';

/**
 * Service for interacting with purchase invoice related backend endpoints.
 * Keep payloads minimal to avoid sending large base64 attachment blobs unnecessarily.
 */
export const invoiceService = {
    /**
     * Fetches a combined payload containing the invoice and related lookup data (accounts, dimensions, tax codes).
     */
    getInvoiceDataCombined() {
        return apiClient.get('/invoice/combined');
    },
    /**
     * Fetches the current invoice.
     */
    getInvoice() {
        return apiClient.get('/invoice');
    },
    /**
     * Updates an invoice. Attachments are stripped to avoid large payload resubmission.
     * @param data Invoice data to update.
     */
    updateInvoice(data: PurchaseInvoice | null) {
        if (data) {
            data.attachments = [];
        }
        return apiClient.post('/invoice', data);
    },
    /**
     * Re-assigns an invoice to a different user.
     * @param invoiceId The internal invoice id.
     * @param userId The id of the user the invoice should be assigned to.
     * @returns Axios promise resolving backend response.
     * @throws {Error} Network or backend errors are propagated.
     */
    reassignInvoice(invoiceId: string, userId: string) {
        return apiClient.post('/invoice/re-assign', { invoiceId, userId });
    }
};